<template>
  <div class="intro">
    <img src="static/apple-icon.png" alt="" class="logo" />
    <div>
      {{ $t("intro.welcome") }}
      <b>{{ $t("intro.title") }}</b> {{ $t("intro.forClocktower") }}
      {{ $t("intro.addPlayersBeforeMenu") }}
      <span class="button" @click="toggleMenu">
        <font-awesome-icon icon="cog" /> {{ $t("intro.menu") }}
      </span>
      {{ $t("intro.addPlayersAfterMenu", { addKey: "[A]", joinKey: "[J]" }) }}
      <br />
      <div class="footer">
        {{ $t("intro.footerBeforeGithub") }}
        <a href="https://github.com/nicholas-eden/townsquare" target="_blank"
          >GitHub</a
        >. {{ $t("intro.footerAfterGithub") }}
      </div>
    </div>
    <img src="../assets/community-created-content.webp" alt="" class="ccc" />
    <a
      class="redirect"
      v-if="language === 'zh-CN'"
      href="https://clocktower.gstonegames.com"
    >
      <img src="../assets/gstone.webp" class="gstone" alt="" />
      {{ $t("intro.chineseRedirect") }}
    </a>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      language: window.navigator.userLanguage || window.navigator.language,
    };
  },
  methods: mapMutations(["toggleMenu"]),
};
</script>

<style scoped lang="scss">
.intro {
  text-align: center;
  width: 50%;
  font-size: 120%;
  position: absolute;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  border: 3px solid black;
  border-radius: 10px;
  z-index: 3;
  display: flex;
  justify-content: center;
  a {
    color: white;
  }
  a.redirect {
    display: block;
    text-decoration: none;
    position: absolute;
    top: 100%;
    margin-top: 2vh;
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: 3px solid black;
    border-radius: 10px;

    &:hover {
      color: red;
    }
    img {
      width: 120px;
      display: block;
      margin: auto auto 1vh;
    }
  }

  img.logo {
    position: absolute;
    bottom: 100%;
    width: 25vh;
    margin-bottom: 2vh;
    max-width: 192px;
    border-radius: 50%;
    box-shadow: 0 0 10px black;
    border: 3px solid black;
  }

  img.ccc {
    position: absolute;
    top: 100%;
    width: 25vh;
    margin-top: 2vh;
    max-width: 192px;
    filter: drop-shadow(0 0 10px black);
  }

  .footer {
    font-size: 60%;
    opacity: 0.75;
  }
}
</style>
